












import { Component, Vue, Watch } from 'vue-property-decorator'

import MonitorList from '@/components/geofence_monitor/MonitorList.vue'
import MonitorMessages from '@/components/geofence_monitor/MonitorMessages.vue'

// Models
import GeofenceModel from '@/_models/GeofenceModel'
import GeofenceMessage from '@/_interfaces/GeofenceMessage'

// Utils
import { Filter } from '@/_utils/filter'
import { showUserChangeLocation } from '@/_utils/geofence-messages'

@Component({
  components: {
    MonitorList,
    MonitorMessages,
  },
})
export default class MonitorPage extends Vue {
  filterUtilList = new Filter('filter_monitor_list')
  refreshTimer: any
  setting: any
  /* tslint:disable:variable-name */
  _isDestroyed: boolean = false
  seletedGeofence: GeofenceModel = new GeofenceModel()
  messages: GeofenceMessage[] = []
  isBindingStatus: boolean = true
  isChangedGeofence: boolean = false
  isFetchLoading: boolean = true

  get isLoading() {
    return this.$store.state.geofences.loading
  }

  get geofences() {
    return this.$store.state.geofences.all.items
  }

  get monitors() {
    return this.$store.state.geofences.item.monitor
  }

  @Watch('monitors') onMonitorsChange(newValue) {
    if (this.isChangedGeofence) {
      return
    }
    this.messages = showUserChangeLocation(
      this.messages,
      this._isDestroyed,
      this.setting.card_off_after_minutes ?? 1,
      newValue
    )
  }

  async getAutoRefeshMonitor(seleted: GeofenceModel) {
    // Reset all timeout before
    clearInterval(this.refreshTimer)

    this.isFetchLoading = true
    const refreshAfter = this.setting.refresh_location_time * 1000 + 1000

    // init first time load
    await this.doFetchMonitor(seleted)

    this.refreshTimer = setInterval(() => {
      if (!this.isLoading) {
        this.doFetchMonitor(seleted).finally(() => {
          if (seleted._id === this.seletedGeofence._id) {
            this.isChangedGeofence = false
          }
        })
      }
    }, refreshAfter)
  }

  async doFetchMonitor(seleted: GeofenceModel) {
    return await this.$store
      .dispatch('geofences/getMonitor', {
        ...this.convertParam(seleted),
        isLoading: this.isFetchLoading,
      })
      .then(() => {
        if (this._isDestroyed) {
          clearInterval(this.refreshTimer)
        }

        this.isFetchLoading = false
        this.isBindingStatus = false
        setTimeout(() => {
          this.isBindingStatus = true
        }, 300)
      })
  }

  convertParam(selected: GeofenceModel) {
    return {
      geofence_id: selected._id,
      user_ids: selected.geofence_users.map((item) => item._id),
    }
  }

  async created() {
    await this.$store.dispatch('geofences/getAll')
    await this.$store.dispatch('users/getAll')

    await this.$store.dispatch('settings/getFromLocal').then(async (setting) => {
      this.setting = setting
      const localGeofenceId = this.filterUtilList.get('')
      const routeGeofenceId = this.$route.params.geofence_id
      const geofenceIdPriority = routeGeofenceId || localGeofenceId
      let geofenceToFetch = new GeofenceModel()

      geofenceToFetch = geofenceIdPriority
        ? this.geofences.find((geo: GeofenceModel) => geo._id === geofenceIdPriority)
        : this.geofences[0]

      this.fetchDataMonitor(geofenceToFetch)
    })
  }

  fetchDataMonitor(geofence: GeofenceModel) {
    if (!geofence._id) {
      return
    }

    this.setSelectedGeofence(geofence)
    ;(this.$refs as any).minitorList.pageFilters.searchQuery = geofence?.name
    this.getAutoRefeshMonitor(geofence)
  }

  setSelectedGeofence(selected: GeofenceModel) {
    this.seletedGeofence = selected
    /* tslint:disable-next-line */
    ;(window as any)['geofence_fetch_id'] = selected._id
  }

  beforeDestroy() {
    this._isDestroyed = true
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }

    /* tslint:disable-next-line */
    delete (window as any)['geofence_fetch_id']

    this.$store.dispatch('resetAllModulesState', ['geofences'])
  }
}
